import React, { useState, useContext } from 'react';
import axios from '../api/axiosConfig';
import { AuthContext } from '../context/AuthContext';
import Sidebar from '../components/Sidebar';
import Navbar from '../components/Navbar';
import './Dashboard.css';

const DataRecovery = () => {
  const { user } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleInitModule = async () => {
    try {
      setLoading(true);
      const response = await axios.post('/api/automation/init-module');
      alert(response.data.message);
      window.location.reload();
    } catch (err) {
      alert('Error: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleClearOrganisms = async () => {
    if (!window.confirm('¿Estás seguro de que deseas eliminar TODOS los nombres de organismos de tránsito registrados? Esto permitirá que el nuevo escáner los detecte correctamente.')) {
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post('/api/automation/clear-organism-data');
      alert(response.data.message);
      setResults(null);
      setMessage('🧹 ' + response.data.message);
    } catch (err) {
      alert('Error: ' + (err.response?.data?.message || err.message));
    } finally {
      setLoading(false);
    }
  };

  const handleStartRecovery = async () => {
    if (!window.confirm('¿Deseas iniciar la revisión de todos los PDFs para extraer documentos faltantes? Este proceso puede tardar unos minutos.')) {
      return;
    }

    setLoading(true);
    setMessage('Iniciando proceso de recuperación...');
    setError('');
    setResults(null);

    try {
      const response = await axios.post('/api/automation/recover-pdf-data');
      setResults(response.data);
      setMessage('✅ ' + response.data.message);
    } catch (err) {
      console.error('Error en recuperación de datos:', err);
      setError('❌ Error: ' + (err.response?.data?.message || 'Error al ejecutar la recuperación de datos.'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-layout">
      <Sidebar userRole={user?.role} />
      
      <div className="main-content">
        <Navbar title="🛠️ Recuperación de Datos" />

        <div className="page-content">
          <header className="dashboard-header" style={{ marginBottom: '30px' }}>
            <h2 style={{ fontSize: '24px', color: '#1e293b' }}>Escaneo de PDFs Registrados</h2>
            <p style={{ color: '#64748b' }}>
              Este módulo permite revisar los archivos PDF de los CUPLs ya registrados en la base de datos 
              para extraer el <strong>Tipo de Documento</strong> y el <strong>Número de Documento</strong> 
              que falten, y así incluirlos en los reportes.
            </p>
          </header>

          <div className="dashboard-section" style={{ background: 'white', padding: '30px', borderRadius: '12px', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }}>
            <div style={{ textAlign: 'center', maxWidth: '600px', margin: '0 auto' }}>
              <div style={{ fontSize: '50px', marginBottom: '20px' }}>📄🔍</div>
              <h3>Iniciar Procesamiento Masivo</h3>
              <p style={{ color: '#64748b', marginBottom: '25px' }}>
                El sistema buscará automáticamente los CUPLs que no tienen información de documento 
                e intentará extraerla desde el archivo PDF correspondiente almacenado en el servidor.
              </p>
              
              <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', flexWrap: 'wrap' }}>
                <button 
                  className="btn-primary" 
                  onClick={handleStartRecovery}
                  disabled={loading}
                  style={{ 
                    padding: '12px 30px', 
                    fontSize: '16px', 
                    background: loading ? '#94a3b8' : '#2563eb',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px'
                  }}
                >
                  {loading ? 'Procesando...' : '🚀 Iniciar Revisión de PDFs'}
                </button>

                <button 
                  className="btn-secondary" 
                  onClick={handleClearOrganisms}
                  disabled={loading}
                  style={{ 
                    padding: '12px 20px', 
                    fontSize: '14px',
                    background: '#dc2626',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px'
                  }}
                  title="Eliminar nombres de organismos actuales para re-escanear"
                >
                  🗑️ Limpiar Organismos
                </button>

                <button 
                  className="btn-secondary" 
                  onClick={handleInitModule}
                  disabled={loading}
                  style={{ 
                    padding: '12px 20px', 
                    fontSize: '14px',
                    background: '#64748b',
                    color: 'white',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer'
                  }}
                  title="Si el módulo no aparece en el menú, haz clic aquí para registrarlo en la base de datos"
                >
                  🛠️ Registrar en Menú
                </button>
              </div>
            </div>

            {message && (
              <div style={{ 
                marginTop: '30px', 
                padding: '15px', 
                backgroundColor: error ? '#fee2e2' : '#dcfce7', 
                color: error ? '#b91c1c' : '#166534', 
                borderRadius: '8px', 
                border: `1px solid ${error ? '#fecaca' : '#bbf7d0'}` 
              }}>
                {message || error}
              </div>
            )}

            {results && (
              <div style={{ marginTop: '30px' }}>
                <div className="stats-grid">
                  <div className="stat-card">
                    <span className="stat-label">Pendientes Iniciales</span>
                    <span className="stat-value">{results.total_pending}</span>
                  </div>
                  <div className="stat-card success">
                    <span className="stat-label">Actualizados con Éxito</span>
                    <span className="stat-value" style={{ color: '#059669' }}>{results.updated}</span>
                  </div>
                  <div className="stat-card danger">
                    <span className="stat-label">Errores / Sin PDF</span>
                    <span className="stat-value" style={{ color: '#dc2626' }}>{results.errors + (results.total_pending - results.updated - results.errors)}</span>
                  </div>
                </div>

                <div style={{ marginTop: '20px' }}>
                  <h4 style={{ marginBottom: '10px' }}>Detalles del Proceso:</h4>
                  <div style={{ 
                    maxHeight: '300px', 
                    overflowY: 'auto', 
                    border: '1px solid #e2e8f0', 
                    borderRadius: '8px',
                    fontSize: '13px'
                  }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead style={{ background: '#f8fafc', position: 'sticky', top: 0 }}>
                        <tr>
                          <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #e2e8f0' }}>CUPL</th>
                          <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #e2e8f0' }}>Estado</th>
                          <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #e2e8f0' }}>Documento</th>
                          <th style={{ padding: '10px', textAlign: 'left', borderBottom: '1px solid #e2e8f0' }}>Organismo</th>
                        </tr>
                      </thead>
                      <tbody>
                        {results.details.map((item, idx) => (
                          <tr key={idx} style={{ borderBottom: '1px solid #f1f5f9' }}>
                            <td style={{ padding: '8px 10px' }}>{item.cupl}</td>
                            <td style={{ padding: '8px 10px' }}>
                              <span style={{ 
                                padding: '2px 8px', 
                                borderRadius: '12px', 
                                fontSize: '11px',
                                backgroundColor: item.status === 'success' ? '#dcfce7' : '#f1f5f9',
                                color: item.status === 'success' ? '#166534' : '#64748b'
                              }}>
                                {item.status}
                              </span>
                            </td>
                            <td style={{ padding: '8px 10px' }}>
                              {item.status === 'success' ? item.doc : '-'}
                            </td>
                            <td style={{ padding: '8px 10px', fontSize: '11px', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {item.status === 'success' ? item.organism : item.status === 'pdf_not_found' ? 'PDF no encontrado' : item.message || '-'}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataRecovery;
